import { getEntity, getEntitySubdomain, getNumericalEntityId } from '@opengov/app-core/entity/selectors';
import { createSelector, createStructuredSelector } from '@opengov/compose-app/reselect';
import { selectFeatureFlags } from '@opengov/feature-flag/launchDarkly';
import { getLocation } from '@opengov/compose-app-router/selectors';

import { storiesMsgs } from '../../locale';
import { selectStoriesPublicationFlag, selectStoriesProgressTrackerFlag } from '../common/flags';
import { IStoriesSettingsProps } from '../components/StoriesSettings';

export const selectStoriesSettingsProps = createStructuredSelector<any, IStoriesSettingsProps>({
  storyMarginsEnabled: createSelector(selectFeatureFlags, (flags) =>
    flags.get('product-stories-feature-story-margins')
  ),
  entityName: createSelector(getEntity, (entity) => entity.display_name),
  entityUuid: createSelector(getEntity, (entity) => entity.uuid),
  entityId: getNumericalEntityId,
  entitySubdomain: getEntitySubdomain,
  messages: createSelector(storiesMsgs, (msgs) => ({ ...msgs.storiesSettings })),
  activeTab: createSelector(getLocation, (location) => location.params?.tab ?? ''),
  displayPublicationTab: selectStoriesPublicationFlag,
  showProgressTracker: selectStoriesProgressTrackerFlag
});
